import React, { useState, useEffect, useCallback, useMemo } from 'react';

// ÜRET = ROUTINE OTOMASYONU KONTROLÜ (2026-10-19, kullanıcı kararları: yalnız süper admin;
// durum + sıra, tek routine / grup çalıştır, aç/kapat, duraklat). Telegram komutlarının
// (/sira /calistir /grup-calistir /ac /kapat /durdur /baslat) panel karşılığı — backend
// `/api/otomasyon`, mantık services/routineKontrol.js'te Telegram'la ortak. Panel yalnız
// niyet yazar; dispatcher en geç 5 dk içinde turu başlatır, bitince Telegram'a bildirim gelir.
// Eski ekran (/api/boru-hatti/uret …) 2026-04-14'ten beri 410 dönen uçları çağırıyordu.

const HAL = {
  calisiyor: { etiket: 'Çalışıyor', sinif: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  bekliyor: { etiket: 'Slot bekliyor', sinif: 'bg-blue-50 text-blue-700 border-blue-200' },
  sirada: { etiket: 'Sırada', sinif: 'bg-gray-50 text-gray-600 border-gray-200' },
  kapali: { etiket: 'Kapalı', sinif: 'bg-white text-gray-400 border-gray-200' },
};

const trKisa = (v) => (v ? new Date(v).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Istanbul' }) : '—');

const dugme = 'px-2.5 py-1.5 rounded-md border text-xs font-medium disabled:opacity-40 disabled:cursor-not-allowed';

export default function Uretim({ apiUrl, authFetch, onGeri }) {
  const [veri, setVeri] = useState(null);
  const [hata, setHata] = useState('');
  const [bilgi, setBilgi] = useState('');
  const [mesgul, setMesgul] = useState('');
  const [kategori, setKategori] = useState('uret');
  const [ara, setAra] = useState('');

  const yukle = useCallback(async () => {
    try {
      const r = await authFetch(`${apiUrl}/api/otomasyon/durum`);
      const d = await r.json();
      if (!r.ok) throw new Error(d.hata || 'Durum alınamadı');
      setVeri(d);
      setHata('');
    } catch (e) {
      setHata(e.message);
    }
  }, [apiUrl, authFetch]);

  useEffect(() => {
    yukle();
    const t = setInterval(yukle, 30000);
    return () => clearInterval(t);
  }, [yukle]);

  const istek = async (anahtar, yol, secenek, basariMetni) => {
    setMesgul(anahtar); setHata(''); setBilgi('');
    try {
      const r = await authFetch(`${apiUrl}/api/otomasyon${yol}`, secenek);
      const d = await r.json();
      if (!r.ok) {
        throw new Error(d.hata === 'routine_kapali' ? 'Routine kapalı — önce açın.' : (d.hata || 'İşlem başarısız'));
      }
      setBilgi(basariMetni(d));
      await yukle();
    } catch (e) {
      setHata(e.message);
    } finally {
      setMesgul('');
    }
  };

  const duraklatildi = !!(veri && veri.sistem.duraklatildi);
  const dispNotu = duraklatildi ? ' Sistem DURAKLATILMIŞ — "Başlat" denene kadar tur başlamaz.' : ' Dispatcher en geç 5 dk içinde başlatır.';

  const calistir = (ad) => istek(`r:${ad}`, `/routine/${encodeURIComponent(ad)}/calistir`, { method: 'POST' },
    () => `Sıraya alındı: ${ad}.${dispNotu}`);
  const acKapat = (ad, enabled) => istek(`t:${ad}`, `/routine/${encodeURIComponent(ad)}`,
    { method: 'PATCH', body: JSON.stringify({ enabled }) }, () => `${enabled ? 'Açıldı' : 'Kapatıldı'}: ${ad}`);
  const grupCalistir = (g) => {
    if (!window.confirm(`"${g.etiket}" grubundaki ${g.acik} açık routine şimdi sıraya alınsın mı?\nKota harcar.`)) return;
    istek(`g:${g.ad}`, `/grup/${g.ad}/calistir`, { method: 'POST' },
      (d) => (d.sirada.length ? `${d.sirada.length} routine sıraya alındı (${d.etiket}).${dispNotu}` : `Bu grupta açık routine yok (${d.etiket}).`));
  };
  const sistemDegistir = () => {
    const durdur = !duraklatildi;
    if (durdur && !window.confirm('Tüm sistem duraklatılsın mı? Süren turlar biter, yeni tur başlamaz.')) return;
    istek('sistem', '/sistem', { method: 'PATCH', body: JSON.stringify({ duraklatildi: durdur }) },
      () => (durdur ? 'Sistem duraklatıldı.' : 'Sistem başlatıldı — dispatcher kaldığı yerden devam eder.'));
  };

  const routineler = useMemo(() => {
    if (!veri) return [];
    const q = ara.trim().toLowerCase();
    return veri.routineler.filter(x =>
      (kategori === 'hepsi' || (kategori === 'uret' ? x.kategori === 'uret' : x.kategori !== 'uret'))
      && (!q || x.routine_adi.toLowerCase().includes(q) || (x.komut || '').toLowerCase().includes(q)));
  }, [veri, kategori, ara]);

  const sayac = useMemo(() => {
    const s = { calisiyor: 0, bekliyor: 0, sirada: 0, kapali: 0 };
    (veri ? veri.routineler : []).forEach(x => { s[x.hal] = (s[x.hal] || 0) + 1; });
    return s;
  }, [veri]);

  return (
    <div className="max-w-6xl mx-auto">
      <div className="flex flex-wrap items-center gap-3 mb-5">
        <button onClick={onGeri} className="px-3 py-1.5 text-xs border border-gray-300 rounded-lg hover:bg-gray-50">← Geri</button>
        <h2 className="text-lg font-bold text-gray-800">▶ Üretim Otomasyonu</h2>
        <span className="text-xs text-gray-400">Telegram routine komutlarının panel karşılığı · 30 sn'de bir yenilenir</span>
        <button onClick={yukle} className={`${dugme} ml-auto border-gray-300 bg-white text-gray-700 hover:bg-gray-50`}>↻ Yenile</button>
      </div>

      {hata && <div className="mb-3 p-3 bg-red-50 border border-red-300 rounded-lg text-red-700 text-sm">{hata}</div>}
      {bilgi && <div className="mb-3 p-3 bg-green-50 border border-green-300 rounded-lg text-green-700 text-sm">{bilgi}</div>}

      {!veri ? (
        !hata && <div className="py-10 text-center text-gray-400 text-sm">Yükleniyor…</div>
      ) : (
        <>
          {/* SİSTEM DURUMU (/otomasyon + /sira özeti) */}
          <div className="bg-white border border-gray-200 rounded-xl p-4 mb-4 shadow-sm flex flex-wrap items-center gap-x-6 gap-y-3">
            <div className="flex items-center gap-2">
              <span className={`w-2.5 h-2.5 rounded-full ${duraklatildi ? 'bg-amber-500' : 'bg-emerald-500'}`} aria-hidden="true" />
              <span className="text-sm font-semibold text-gray-800">{duraklatildi ? 'Duraklatıldı' : 'Çalışıyor'}</span>
              <button onClick={sistemDegistir} disabled={mesgul === 'sistem'} data-testid="sistem-dugme"
                className={`${dugme} ${duraklatildi ? 'border-emerald-600 bg-emerald-600 text-white hover:bg-emerald-700' : 'border-amber-300 bg-white text-amber-700 hover:bg-amber-50'}`}>
                {duraklatildi ? '▶ Başlat' : '⏸ Durdur'}
              </button>
            </div>
            <div className="text-xs text-gray-500">Aktif hesap: <b className="text-gray-800">{veri.sistem.aktif_hesap || '?'}</b></div>
            <div className="flex flex-wrap gap-2 text-xs">
              {['calisiyor', 'bekliyor', 'sirada', 'kapali'].map(h => (
                <span key={h} className={`px-2 py-0.5 rounded-full border ${HAL[h].sinif}`}>{HAL[h].etiket}: <b>{sayac[h] || 0}</b></span>
              ))}
            </div>
            {veri.sistem.notlar && <div className="w-full text-xs text-gray-400">Son not: {veri.sistem.notlar}</div>}
          </div>

          {/* GRUPLAR (/grup-calistir) */}
          <div className="bg-white border border-gray-200 rounded-xl p-4 mb-4 shadow-sm">
            <div className="text-sm font-semibold text-gray-700 mb-3">Grup çalıştır <span className="font-normal text-xs text-gray-400">— yalnız açık routine'ler sıraya alınır</span></div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
              {veri.gruplar.map(g => (
                <div key={g.ad} className="flex items-center gap-2 rounded-lg border border-gray-200 px-3 py-2">
                  <div className="min-w-0 flex-1">
                    <div className="truncate text-sm font-medium text-gray-800">{g.etiket}</div>
                    <div className="text-[11px] text-gray-400">{g.acik}/{g.toplam} açık</div>
                  </div>
                  <button onClick={() => grupCalistir(g)} disabled={!g.acik || mesgul === `g:${g.ad}`}
                    className={`${dugme} border-blue-600 bg-blue-600 text-white hover:bg-blue-700`}>▶ Çalıştır</button>
                </div>
              ))}
            </div>
          </div>

          {/* ROUTINE LİSTESİ (/routine-listele + /calistir + /ac /kapat) */}
          <div className="bg-white border border-gray-200 rounded-xl shadow-sm">
            <div className="flex flex-wrap items-center gap-2 px-4 py-3 border-b border-gray-100">
              <div className="flex border border-gray-300 rounded overflow-hidden" role="group" aria-label="Kategori">
                {[['uret', 'Üretim'], ['bakim', 'Bakım'], ['hepsi', 'Hepsi']].map(([v, l]) => (
                  <button key={v} onClick={() => setKategori(v)} aria-pressed={kategori === v}
                    className={`px-2.5 py-1.5 text-xs ${kategori === v ? 'bg-blue-600 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'}`}>{l}</button>
                ))}
              </div>
              <input value={ara} onChange={e => setAra(e.target.value)} placeholder="Routine ara…" aria-label="Routine ara"
                className="px-2 py-1.5 border border-gray-300 rounded text-xs w-48" />
              <span className="ml-auto text-xs text-gray-400">{routineler.length} routine</span>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-xs">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="text-left font-semibold px-4 py-2">Routine</th>
                    <th className="text-left font-semibold px-2 py-2">Durum</th>
                    <th className="text-left font-semibold px-2 py-2">Son çalışma</th>
                    <th className="text-left font-semibold px-2 py-2">Sonraki</th>
                    <th className="text-right font-semibold px-4 py-2">İşlem</th>
                  </tr>
                </thead>
                <tbody>
                  {routineler.map(x => (
                    <tr key={x.routine_adi} className="border-t border-gray-100">
                      <td className="px-4 py-2">
                        <div className="font-mono text-gray-800">{x.routine_adi}</div>
                        <div className="text-[11px] text-gray-400">{x.komut} · <span className="font-mono">{x.cron}</span></div>
                      </td>
                      <td className="px-2 py-2"><span className={`px-2 py-0.5 rounded-full border ${HAL[x.hal].sinif}`}>{HAL[x.hal].etiket}</span></td>
                      <td className="px-2 py-2 text-gray-600">{trKisa(x.son_calisma)}{x.son_sonuc ? <span className="text-gray-400"> · {x.son_sonuc}{x.son_hesap ? ` (${x.son_hesap})` : ''}</span> : null}</td>
                      <td className="px-2 py-2 text-gray-600">{x.enabled ? trKisa(x.sonraki_calisma) : '—'}</td>
                      <td className="px-4 py-2">
                        <div className="flex justify-end gap-1.5">
                          <button onClick={() => acKapat(x.routine_adi, !x.enabled)} disabled={mesgul === `t:${x.routine_adi}`}
                            className={`${dugme} border-gray-300 bg-white text-gray-700 hover:bg-gray-50`}>{x.enabled ? 'Kapat' : 'Aç'}</button>
                          <button onClick={() => calistir(x.routine_adi)} disabled={!x.enabled || x.hal === 'calisiyor' || mesgul === `r:${x.routine_adi}`}
                            title={!x.enabled ? 'Kapalı routine çalıştırılamaz — önce açın' : 'Şimdi çalıştır'}
                            className={`${dugme} border-blue-600 bg-blue-600 text-white hover:bg-blue-700`}>▶ Şimdi</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {!routineler.length && <tr><td colSpan={5} className="px-4 py-6 text-center text-gray-400">Eşleşen routine yok.</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
